
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { empty, singleton, append, delay, toArray } from "../../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { OnTableRowClick$1, ColumnDefinition$1, CellContent } from "../../../../Widgets/Table/Types.js";
import { bind, map, defaultArg } from "../../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { Hierarchy_getPath } from "../../../../Shared/Location.js";
import { singleton as singleton_1, ofArray, toArray as toArray_1, tryFind } from "../../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { createObj, equals } from "../../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join, concat } from "../../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { roleToString } from "../../../../Shared/Helper.js";
import { roleDisplayName } from "../../../../Common.js";
import { reactApi, reactElement } from "../../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { UserManagementTab, UserManagementOverviewTabs } from "../../OverviewTabs.js";
import { TableControl$1, Table } from "../../../../Widgets/Table/Table.js";
import { RouterModule_nav, RouterModule_encodeParts } from "../../../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import User_Add_Plus from "../../../../../public/assets/icons/User_Add_Plus.svg";
import { React_useElmish_Z6C327F2E } from "../../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { Skeleton } from "../../../../Components/Skeleton.js";

function UsersOverview(props) {
    let elems, TableRows, Options;
    const t = useTranslation()[0];
    const columnDefinitions = toArray(delay(() => append(singleton(new ColumnDefinition$1("name", "", t("general.name"), (dto) => (new CellContent(0, [dto.Name])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("personnelNumber", "", t("user.personnel_number"), (dto_1) => (new CellContent(0, [dto_1.PersonnelNumber])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("emailPhoneNumber", "", t("user.email_mobile_number"), (dto_2) => {
        const matchValue = dto_2.LoginInformation;
        return (matchValue.tag === 1) ? (new CellContent(0, [matchValue.fields[0]])) : (new CellContent(0, [matchValue.fields[0]]));
    }, "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("department", "", t("user.department"), (dto_3) => (new CellContent(0, [dto_3.Department])), "select", "text")), delay(() => append(singleton(new ColumnDefinition$1("location", "", t("general.location"), (dto_4) => (new CellContent(0, [defaultArg(map((location_1) => Hierarchy_getPath(props.Locations, location_1), tryFind((location) => equals(location.Id, dto_4.LocationId), props.Locations)), "")])), "locationSelect", "text")), delay(() => append(props.AccountSettings.BusinessUnitsEnabled ? singleton(new ColumnDefinition$1("businessUnitName", "", t("business_units.business_unit"), (dto_5) => (new CellContent(0, [defaultArg(dto_5.BusinessUnitNames, "")])), "select", "text")) : empty(), delay(() => singleton(new ColumnDefinition$1("role", "", t("general.role"), (dto_6) => {
        const matchValue_1 = bind((assignment_1) => tryFind((role) => equals(role.Id, assignment_1.RoleId), props.Roles), tryFind((assignment) => (assignment.UserId === dto_6.Id), props.Assignments));
        return (matchValue_1 == null) ? (new CellContent(0, [t(concat("role.", ...roleToString(dto_6.Role)))])) : (new CellContent(0, [roleDisplayName(t, matchValue_1)]));
    }, "select", "text"))))))))))))))));
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems = [createElement(UserManagementOverviewTabs, {
        RestEnabled: props.AccountSettings.RestEnabled,
        SelectedTab: new UserManagementTab(0, []),
    }), createElement(Table, (TableRows = toArray_1(props.Users), (Options = {
        BorderStyle: "row",
        CSVDownload: false,
        ConfigurableColumns: false,
        CustomTableFilters: false,
        DefaultSortColumn: ["name", "asc"],
        Fullscreen: false,
        GlobalSearch: true,
        OnRowClick: new OnTableRowClick$1(1, [(dto_7) => RouterModule_encodeParts(ofArray(["settings", "users", dto_7.Id]), 1)]),
        RowSelection: "disabled",
        SaveTableConfiguration: false,
    }, {
        ColumnDefinitions: columnDefinitions,
        Controls: singleton_1(new TableControl$1(t("user.create_new_user"), User_Add_Plus(), (_arg) => {
            RouterModule_nav(ofArray(["settings", "users", "new"]), 1, 1);
        }, false, false, "user-create")),
        Options: Options,
        TableKey: "not-defined-table",
        TableRows: TableRows,
    })))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function UsersOverviewView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), undefined, undefined);
    const state_1 = patternInput[0];
    const matchValue = state_1.Users;
    const matchValue_1 = state_1.CustomerConfiguration;
    const matchValue_2 = state_1.Locations;
    const matchValue_3 = state_1.Roles;
    const matchValue_4 = state_1.Assignments;
    let matchResult, assignments, customerConfiguration, locations, roles, users;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_3.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_4.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        assignments = matchValue_4.fields[0];
        customerConfiguration = matchValue_1.fields[0];
        locations = matchValue_2.fields[0];
        roles = matchValue_3.fields[0];
        users = matchValue.fields[0];
    }
    switch (matchResult) {
        case 0:
            return createElement(UsersOverview, {
                AccountSettings: props.AccountSettings,
                Assignments: assignments,
                CustomerConfiguration: customerConfiguration,
                Dispatch: patternInput[1],
                Locations: locations,
                Roles: roles,
                UserData: props.UserData,
                Users: users,
            });
        default:
            return createElement(Skeleton, {
                Variant: "table",
            });
    }
}

